import React, {useContext} from 'react';
import {FaExpand, FaCompress} from "react-icons/fa";
import {AppCtx} from "../../../AppCtx";

export default () => {
  const {isFullScreen, setIsFullScreen, setIsTopMenuVisible} = useContext(AppCtx);
  const label = isFullScreen ? "Wyłącz pełny ekran" : "Włącz pełny ekran";
  return <div onClick={()=>{setIsFullScreen(!isFullScreen);setIsTopMenuVisible(!isFullScreen);}}
              style={{cursor:'pointer',borderRadius:'30%',padding:'5px'}}
              role="button" tabIndex={0} aria-label={label} title={label}>
    {isFullScreen ? 
      <FaCompress style={{color: 'var(--menu-icon-color)'}}/> : 
      <FaExpand style={{color: 'var(--menu-icon-color)'}}/>}
  </div>;
};
